import React from "react";
import CreateCaseParty from "../../internal/CreateParty/CreateCaseParty";

const Index = ({ draftId, resolutionKind }) => {
  return <CreateCaseParty draftId={draftId} resolutionKind={resolutionKind} />;
};

export default Index;
